import React, { useState, useEffect } from 'react';
import { Table, Typography, Tooltip, Button, Row, Col, Modal, Select, Input, message, Popconfirm,Spin } from 'antd';
import ApiService from '../Components/apiService';
import { DeleteOutlined, EditOutlined, CopyOutlined } from '@ant-design/icons';
import { BASE_URL,DateFormat,DateTimeFormat } from '../Components/Constant';
import Cookies from 'js-cookie';
import AccessPolicyGroupDetailPage from './AccessPolicyGroupDetailPage';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';

const { Title } = Typography;
const { Option } = Select;


const AccessPolicyGroup = () => {

    const currentUserId = Cookies.get('userId');
    const [accessPolicyGroups, setAccessPolicyGroups] = useState([]);
    const [accessPolicy, setAccessPolicy] = useState([]);
    const [createPolicyGroup, setCreatePolicyGroup] = useState(false);
    const [policyGroupName, setPolicyGroupName] = useState('');
    const [selectedAccessPolicies, setSelectedAccessPolicies] = useState([]);
    const [selectedAccessPolciyGroup, setSelectedAccessPolicyGroup] = useState(null);
    const [assignedUser, setAssignedUser] = useState(null);
    const [users, setUsers] = useState([]); // Assuming you will fetch users from an API
    const [showDetailPageForGroup,setShowDetailPageForGroup]=useState(false);
    const [loading, setLoading] = useState(true);  // <-- Added loading state
    const security = useSelector((state) => state.data.items[0]);
    const navigate = useNavigate();

    
    useEffect(() => {
        fetchAccessPolicyGroups();
        fetchAccessPolcies();
        fetchUsers();
    }, [currentUserId]);


    const fetchUsers = async () => {
        try {
            // Replace with the correct API to fetch users
            const apiService = new ApiService(
                `${BASE_URL}/fetch_records/User`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall(navigate);
            setUsers(response?.records);
        } catch (error) {
            console.error('Error fetching users', error);
        }
    };

    const fetchAccessPolicyGroups = async () => {
        try {

            const apiService = new ApiService(
                `${BASE_URL}/get_all`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall();
            setAccessPolicyGroups(response);

        } catch (error) {

            console.log(error);
        }  
        finally {
            setLoading(false);  
        }
    }

    const fetchAccessPolcies = async () => {
        try {
            const apiService = new ApiService(
                `${BASE_URL}/mt_access_policies`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall();
            setAccessPolicy(response);
        } catch (error) {
            console.error('Error fetching access policy', error);
        }
    };

    const handleEditPolicy = (policy) => {
        if(security?.system_settings?.access_policy.edit===false){
            message.error('You dont have permission to edit ');
            return;
        }
        handleCreatePolicyGroup(true);
        setSelectedAccessPolicyGroup(policy);
        setPolicyGroupName(policy?.Name);
        setAssignedUser(policy?.assigned_to_ids);
        setSelectedAccessPolicies(policy?.MtAccessPolicy_ids)
    }

    const handleClonePolicy = (policy) => {
        if(security?.system_settings?.access_policy.create===false){
            message.error('You dont have permission to create ');
            return;
        }
        handleCreatePolicyGroup(true);
        setPolicyGroupName(policy?.Name + ' ' + 'Clone');
        setAssignedUser(policy?.assigned_to_ids);
        setSelectedAccessPolicies(policy?.MtAccessPolicy_ids)
    }

    const deletePolicy = async(policy) => {
        if(security?.system_settings?.access_policy.delete===false){
            message.error('You dont have permission to delete ');
            return;
        }
        try{

            const apiService = new ApiService(
                `${BASE_URL}/delete_access_policy_group/${policy._id}`,
                { 'Content-Type': 'application/json' },
                'DELETE'
            );

            const response =await apiService.makeCall();

            message.success('Access Policy Group deleted successfully');

            fetchAccessPolicyGroups();

        }catch(error){
            message.error('Failed to delete access policy group');
        }

    }

    const handleClick = (policy) => {
        setSelectedAccessPolicyGroup(policy);
        setShowDetailPageForGroup(true);

    }

    const handleCreatePolicyGroup = () => {
        if(security?.system_settings?.access_policy_group.create===false){
            message.error('You dont have permission to create ');
            return;
        }
        setCreatePolicyGroup(true);

    }

    const handleCancel = () => {

        setCreatePolicyGroup(false);
        setPolicyGroupName('');
        setSelectedAccessPolicies([]);
        setAssignedUser([]);
    }

    const handleSave = async () => {
        let apiService = '';
        try {

            if (selectedAccessPolciyGroup?._id) {
                selectedAccessPolciyGroup.Name = policyGroupName;
                selectedAccessPolciyGroup.assigned_to_ids = assignedUser;
                selectedAccessPolciyGroup.MtAccessPolicy_ids=selectedAccessPolicies
                apiService = new ApiService(
                    `${BASE_URL}/update_access_policy_group/${selectedAccessPolciyGroup?._id}`,
                    { 'Content-Type': 'application/json' },
                    'PATCH', selectedAccessPolciyGroup
                );
            } else {
                const body = {
                    mt_access_policy_group: {
                        Name: policyGroupName,
                        assigned_to_ids: assignedUser,
                        MtAccessPolicy_ids:selectedAccessPolicies

                    }
                }
                apiService = new ApiService(
                    `${BASE_URL}/create_access_policy_group`,
                    { 'Content-Type': 'application/json' },
                    'POST', body
                );
            }
            const response = await apiService.makeCall();
            setCreatePolicyGroup(false);
            fetchAccessPolicyGroups();
            message.success('Access Policy Group Created Successfully');
        }
        catch (error) {
            message.error('Failed to create access policy group');
        }


    }

    const getUserNameById = (userId) => {
        const user = users.find((user) => user._id === userId);
        return user ? user.Name : '';
    };
    const getPolicyNameById = (policyId) => {
        const policy = accessPolicy.find((policy) => policy._id === policyId);
        return policy ? policy.Name : '';
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'Name',
            key: 'Name',
            render: (text, policy) => (
                <span
                    onClick={() => handleClick(policy)}
                    style={{ color: '#0070d2', cursor: 'pointer' }}
                >
                    {text}
                </span>
            ),
        },
        {
            title: 'Access Policies',
            dataIndex: 'MtAccessPolicy_ids',
            key: 'MtAccessPolicy_ids',
            render: (accessPolicies) => {
                return accessPolicies?.map((policyId) => getPolicyNameById(policyId)).join(', ') || '';
            },
        },
        {
            title: 'Assigned to Users',
            dataIndex: 'assigned_to_ids',
            key: 'assigned_to_ids',
            render: (assignedUsers) => {
                return assignedUsers?.map((userId) => getUserNameById(userId)).join(', ') || '';
            },
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: 'created_at',
            // width: 100,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
                    
          },
          {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            // width: 100,
            sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
            render: (text) => (
                text && dayjs(text).isValid()
                  ? convertDateToUserTimezone(text, DateTimeFormat)
                  : ''
              ),
                    
          },
    ];
    

    columns.push({
        title: 'Action',
        key: 'operation',
        render: (_, policy) => (
            <>
                <Tooltip title="Edit">
                    <EditOutlined
                        onClick={() => handleEditPolicy(policy)}
                        style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                    />
                </Tooltip>

                <Tooltip title="Clone">
                    <CopyOutlined
                        onClick={() => handleClonePolicy(policy)}
                        style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                    />
                </Tooltip>

                <Tooltip title="Delete">
                    <Popconfirm
                        title="Are you sure you want to delete this policy?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={() => deletePolicy(policy)}
                    >
                        <DeleteOutlined
                            style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
                        />
                    </Popconfirm>
                </Tooltip>
            </>
        ),
    });


    return showDetailPageForGroup ? (
        <AccessPolicyGroupDetailPage
            selectedAccessPolicyGroup={selectedAccessPolciyGroup}
            allUsers={users}
            allAccessPolcies={accessPolicy}
            fetchAccessPolicyGroups={fetchAccessPolicyGroups}
            onBack={() => setShowDetailPageForGroup(false)}
        />
    ) : (
        <div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: '16px' }}>
                    <Col>
                        <Title level={4} style={{ margin: 0 }}>
                            Access Policy Groups
                        </Title>
                    </Col>
                    <Col>
                        <Button type="primary" onClick={handleCreatePolicyGroup}>
                            Create Access Policy Groups
                        </Button>
                    </Col>
                </Row>
            </div>
            <Spin spinning={loading} tip="Loading Access Policies Groups...">
            <Table columns={columns} dataSource={accessPolicyGroups} />
            </Spin>
    
            <Modal
                title="Create Access Policy"
                visible={createPolicyGroup}
                onCancel={handleCancel}
                footer={null}
                width={600}
                zIndex={1002}   // higher than sidebar
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <div style={{ marginBottom: '16px' }}>
                            <label>Name</label>
                            <Input
                                value={policyGroupName}
                                onChange={(e) => setPolicyGroupName(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ marginBottom: '16px' }}>
                            <label>Access Policies</label>
                            <Select
                                mode="multiple"
                                value={selectedAccessPolicies}
                                onChange={setSelectedAccessPolicies}
                                style={{ width: '100%' }}
                            >
                                {accessPolicy.map((policy) => (
                                    <Option key={policy._id} value={policy._id}>
                                        {policy.Name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div style={{ marginBottom: '16px' }}>
                            <label>Assigned to</label>
                            <Select
                                mode="multiple"
                                value={assignedUser}
                                onChange={setAssignedUser}
                                style={{ width: '100%' }}
                            >
                                {users.map((user) => (
                                    <Option key={user._id} value={user._id}>
                                        {user.Name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </Col>
                </Row>
                <Row justify="end">
                    <Col>
                        <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                        <Button type="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Modal>
        </div>
    );
    


}

export default AccessPolicyGroup;